import { IMarketScanResultState } from '../../types';
import { AppActionTypes } from '../actions';
import { Types } from '../actions/market-scan-results-actions';

const marketScanResultsReducer = (
  state: IMarketScanResultState,
  action: AppActionTypes,
): IMarketScanResultState => {
  switch (action.type) {
    case Types.MARKET_SCAN_RESULT_LOADED:
      return {
        ...state,
        currentMarketScanResult: action.data,
      };
    case Types.UPDATE_MARKET_SCAN_RESULT_LOCAL:
      const { currentMarketScanResult } = state;
      const updatedResult = {
        ...currentMarketScanResult,
        ...action.data,
      };
      return {
        ...state,
        currentMarketScanResult: updatedResult,
      };
    case Types.SHOW_HOW_TO_VIDEOS_POPUP:
      return {
        ...state,
        showHowToVideosPopup: true,
      };
    case Types.HIDE_HOW_TO_VIDEOS_POPUP:
      return {
        ...state,
        showHowToVideosPopup: false,
      };
    case Types.SET_PURCHASE_FLOW_ACTIVE:
      return {
        ...state,
        isPurchaseFlowActive: action.active,
      };
    default:
      return state;
  }
};

export default marketScanResultsReducer;
